import http from '../../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/demo/temporaryContractTable',
    //列表查询
    page(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    //新增
    insert(data){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            data: data
        })
    },
    //修改
    updateById(data){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            data: data
        })
    },
    //删除
    deleteById(id){
        return http({
            url: this.baseurl+'/deleteById?id=' + id,
            method: 'post'
        })
    },
    //详情
    selectById(data){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            data: data
        })
    }
}
